export default {
  id: 109,
  title: 'Target #109 - Curtain',
  url: 'https://cssbattle.dev/play/109',
  colors: ['#191919', '#F6E59C'],
  solution:
    '<p><style>body{background:#191919}p{width:40;height:40;border-radius:50%;background:#f6e59c;position:fixed;top:4;left:20;box-shadow:60px 0 #f6e59c,120px 0 #f6e59c,180px 0 #f6e59c,0 60px #f6e59c,60px 60px #f6e59c,120px 60px #f6e59c,0 120px #f6e59c,60px 120px #f6e59c,0 180px #f6e59c}</style>',
}
